export default __webpack_public_path__ + "static/media/banner03.e942ec2a.jpg";